/*
 * Halloween header: the bat swarm (2026).
 *
 * Loaded by sections/header.liquid from Oct 1 until 12:00 AM Nov 1, 2026 (Central), and it stops itself at
 * that moment as well. It plays once per browser session,
 * shortly after the page loads: a harvest moon appears (desktop: in the top bar left of the TXI tile; phones:
 * right of the menu button), a swarm of bats pours out of it to the TXI logo, then leaves (desktop: off to
 * the left across the header; phones: all over the header and up out of sight), and the moon fades.
 *
 * Nothing in the header changes: every element added here sits in one pointer-events:none overlay that is
 * removed when the animation ends, so every link, field and button keeps working underneath it. It does not
 * run for visitors who prefer reduced motion. Add ?bats=1 to any URL to play it again (for review).
 */
(function () {
  // Hard stop: 12:00 AM Nov 1, 2026, Central time (still daylight time that night, so UTC-5). The header
  // section stops loading this file on Nov 1 too; this covers a cached page served after midnight.
  if (Date.now() >= Date.parse('2026-11-01T00:00:00-05:00')) return;
  var KEY = 'usamm-halloween-bats';
  var force = /[?&]bats=1\b/.test(location.search);
  if (matchMedia('(prefers-reduced-motion: reduce)').matches && !force) return;
  try { if (!force && sessionStorage.getItem(KEY)) return; } catch (e) {}

  var BAT = '<svg viewBox="0 0 40 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M20 4.5c.6-1.6.7-2.8.6-3.8l1.3 2.6c1.9.1 3.6.8 4.9 2C29 2.4 33.6.6 40 .9c-2.6 1.9-3.6 4.6-3.6 7.6-2-.9-4.1-.9-6 .2-.9-1.9-2.8-2.9-4.8-2.3-1.9.5-3.3 2.6-5.6 5.6-2.3-3-3.7-5.1-5.6-5.6-2-.6-3.9.4-4.8 2.3-1.9-1.1-4-1.1-6-.2 0-3-1-5.7-3.6-7.6 6.4-.3 11 1.5 13.2 4.3 1.3-1.2 3-1.9 4.9-2L19.4.7c-.1 1 0 2.2.6 3.8z"/></svg>';

  var css =
    '.hh-over { position: absolute; inset: 0; z-index: 50; overflow: hidden; pointer-events: none; }' +
    '.hh-bat { position: absolute; color: #050507; opacity: 0; will-change: transform, opacity;' +
    '  filter: drop-shadow(0 0 1.5px rgba(255, 176, 114, .85)); }' +
    '.hh-bat svg { display: block; width: 100%; transform-origin: 50% 35%; animation: hh-flap .18s ease-in-out infinite alternate; }' +
    '@keyframes hh-flap { from { transform: scaleY(1); } to { transform: scaleY(.55); } }';

  function el(cls, parent, styleText, html) {
    var e = document.createElement('div');
    e.className = cls;
    e.setAttribute('aria-hidden', 'true');
    if (styleText) e.style.cssText = styleText;
    if (html) e.innerHTML = html;
    parent.appendChild(e);
    return e;
  }
  // one bat along a path of [x, y, rotation] points (px, relative to the header), with a duration and delay in ms
  function flyBat(parent, size, path, dur, delay, opacity) {
    var b = el('hh-bat', parent, 'width:' + size + 'px;left:0;top:0;', BAT);
    var frames = path.map(function (p, i) {
      return { transform: 'translate(' + p[0] + 'px,' + p[1] + 'px) rotate(' + (p[2] || 0) + 'deg)',
               opacity: i === 0 || i === path.length - 1 ? 0 : (opacity || 1) };
    });
    var a = b.animate(frames, { duration: dur, delay: delay, easing: 'cubic-bezier(.45,.05,.55,.95)', fill: 'both' });
    a.onfinish = function () { b.remove(); };
    return a;
  }

  var header;
  function swarm() {
    // Plays once. A moon appears for a moment, a swarm of bats pours out of it to the TXI logo (which
    // flickers like a jack-o'-lantern), then the bats leave: off to the left across the header on desktop,
    // all over the header and up out of sight on phones. Then the moon fades and the header is untouched.
    var over = el('hh-over', header), hr = header.getBoundingClientRect(), H = hr.height, W = hr.width;
    var phone = document.documentElement.clientWidth < 769;
    var rel = function (r) { return { x: r.left - hr.left, y: r.top - hr.top, w: r.width, h: r.height, cx: r.left - hr.left + r.width / 2, cy: r.top - hr.top + r.height / 2 }; };
    var tileEl = [].slice.call(header.querySelectorAll('a, div')).filter(function (e) {
      var r = e.getBoundingClientRect();
      if (!/texas issued/i.test(e.textContent) || r.width < 100 || r.width > 420 || r.height < 20) return false;
      // the visible tile: inside the header and actually on screen (the mobile menu holds a hidden copy)
      if (r.top < hr.top || r.bottom > hr.bottom) return false;
      var hit = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      return !!hit && (hit === e || e.contains(hit));
    }).sort(function (a, b) { return a.getBoundingClientRect().width - b.getBoundingClientRect().width; })[0];
    if (!tileEl) { over.remove(); return; }
    var tile = rel(tileEl.getBoundingClientRect());
    var logoEl = tileEl.querySelector('img, svg');
    var logo = logoEl ? rel(logoEl.getBoundingClientRect()) : { cx: tile.x + 50, cy: tile.cy, w: 80, h: 30 };

    // where the moon appears: desktop, in the top bar just left of the TXI tile; phones, right of the menu button
    var mx, my, ms;
    if (phone) {
      var burger = header.querySelector('.main-menu__toggle, summary');
      var b = burger ? rel(burger.getBoundingClientRect()) : { x: 12, y: 16, w: 36, h: 36, cy: 34 };
      ms = 30; mx = b.x + b.w + 14; my = b.cy - ms / 2;
    } else {
      ms = 34; mx = tile.x - ms - 46; my = tile.cy - ms / 2;
    }
    var mcx = mx + ms / 2, mcy = my + ms / 2;
    // a small patch of night behind the moon so it reads on the light top bar
    // ---- the moon: an amber harvest moon that ignites from blood-red, a wavering orange-to-plum haze, a faint
    // misty halo ring, two smoke wisps drifting across its face, and its light cast down in faint rays ----
    if (!document.getElementById('hh-wisp')) {
      // wavering, smoky edges for the haze (an animated turbulence displacement)
      var svgNS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('width', '0'); svg.setAttribute('height', '0'); svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
      svg.innerHTML = '<filter id="hh-wisp" x="-30%" y="-30%" width="160%" height="160%">' +
        '<feTurbulence type="fractalNoise" baseFrequency="0.035" numOctaves="2" seed="7" result="n">' +
        '<animate attributeName="baseFrequency" values="0.03;0.05;0.03" dur="6s" repeatCount="indefinite"/></feTurbulence>' +
        '<feDisplacementMap in="SourceGraphic" in2="n" scale="16" xChannelSelector="R" yChannelSelector="G"/></filter>';
      document.body.appendChild(svg);
    }
    var moonBox = el('hh-moonbox', over, 'position:absolute;left:0;top:0;width:100%;height:100%;');
    var hr2 = ms * (phone ? 1.12 : 1.5);   // haze radius: clears the menu button on phones
    var haze = el('hh-haze', moonBox, 'position:absolute;left:' + (mcx - hr2) + 'px;top:' + (mcy - hr2) + 'px;width:' + hr2 * 2 + 'px;height:' + hr2 * 2 + 'px;border-radius:50%;opacity:0;' +
      'background:radial-gradient(circle, rgba(255,178,84,.9) 0 20%, rgba(244,94,5,.55) 38%, rgba(160,44,96,.22) 58%, rgba(110,40,140,0) 72%);' +
      'filter:url(#hh-wisp) blur(1.5px);');
    var rr = ms * (phone ? 0.95 : 1.9);    // the misty halo ring
    var ring = el('hh-ring', moonBox, 'position:absolute;left:' + (mcx - rr) + 'px;top:' + (mcy - rr) + 'px;width:' + rr * 2 + 'px;height:' + rr * 2 + 'px;border-radius:50%;opacity:0;' +
      'background:radial-gradient(circle, rgba(0,0,0,0) 0 56%, rgba(255,196,128,.5) 63%, rgba(176,96,214,.26) 68%, rgba(0,0,0,0) 74%);filter:blur(.6px);');
    // the light cast down, in faint rays
    var L = phone ? 170 : 260, dir = phone ? 140 : 222, spread = 26;
    var rays = [0, .26, .12, .4, .18, .5, .2, .42, .14, .3, 0], stops = rays.map(function (a, i) {
      return 'rgba(255,' + (160 + Math.round(a * 60)) + ',' + (70 + Math.round(a * 80)) + ',' + a + ') ' + (i * spread * 2 / (rays.length - 1)).toFixed(1) + 'deg';
    }).join(',');
    var beam = el('hh-beam', moonBox, 'position:absolute;left:' + (mcx - L) + 'px;top:' + (mcy - L) + 'px;width:' + L * 2 + 'px;height:' + L * 2 + 'px;opacity:0;' +
      'background:conic-gradient(from ' + (dir - spread) + 'deg at 50% 50%,' + stops + ', rgba(255,160,70,0) 360deg);' +
      '-webkit-mask-image:radial-gradient(circle at 50% 50%, #000 3%, rgba(0,0,0,.5) 32%, transparent 70%);mask-image:radial-gradient(circle at 50% 50%, #000 3%, rgba(0,0,0,.5) 32%, transparent 70%);' +
      'filter:blur(3px);');
    // the harvest moon: amber face, burnt-orange rim, rust patches
    var moon = el('hh-hmoon', moonBox, 'position:absolute;left:' + mx + 'px;top:' + my + 'px;width:' + ms + 'px;height:' + ms + 'px;border-radius:50%;opacity:0;' +
      'background:radial-gradient(circle at 63% 38%, rgba(150,58,18,.38) 0 10%, rgba(150,58,18,0) 15%),' +
      'radial-gradient(circle at 40% 63%, rgba(150,58,18,.32) 0 13%, rgba(150,58,18,0) 19%),' +
      'radial-gradient(circle at 72% 70%, rgba(150,58,18,.24) 0 7%, rgba(150,58,18,0) 11%),' +
      'radial-gradient(circle at 34% 30%, #fff6de 0, #ffd690 24%, #f2a03e 56%, #c9561b 86%, #8f300f 100%);' +
      'box-shadow:inset -3px -3px 7px rgba(90,24,0,.5), 0 0 8px 2px rgba(255,172,72,.9), 0 0 22px 8px rgba(244,94,5,.5);');
    // two smoke wisps drifting across the moon's face, only visible near the moon
    var veilW = ms * 3, veilH = ms * 1.6;
    var veil = el('hh-veil', moonBox, 'position:absolute;left:' + (mcx - veilW / 2) + 'px;top:' + (mcy - veilH / 2) + 'px;width:' + veilW + 'px;height:' + veilH + 'px;overflow:hidden;' +
      // only over the moon's face (and a hair beyond), so the smoke never smudges the light top bar
      '-webkit-mask-image:radial-gradient(circle ' + ms * 0.62 + 'px at 50% 50%, #000 75%, transparent 100%);mask-image:radial-gradient(circle ' + ms * 0.62 + 'px at 50% 50%, #000 75%, transparent 100%);');
    [[0.36, 600, 3600, 0.8], [0.68, 1300, 3400, 0.65]].forEach(function (w) {
      var wisp = el('hh-wisp', veil, 'position:absolute;left:' + (veilW / 2 - ms * 1.1) + 'px;top:' + (veilH * w[0] - ms * 0.14) + 'px;width:' + ms * 2.2 + 'px;height:' + ms * 0.28 + 'px;border-radius:50%;opacity:0;' +
        'background:radial-gradient(ellipse at 50% 50%, rgba(34,14,42,.9) 0 35%, rgba(34,14,42,0) 70%);filter:blur(1.5px);');
      wisp.animate([{ transform: 'translateX(' + ms * 1.5 + 'px)', opacity: 0 }, { opacity: w[3], offset: 0.3 }, { opacity: w[3], offset: 0.7 }, { transform: 'translateX(' + -ms * 1.5 + 'px)', opacity: 0 }],
        { duration: w[2], delay: w[1], fill: 'both', easing: 'linear' });
    });

    // it ignites: blood-red and dim, warming to amber
    moon.animate([{ opacity: 0, transform: 'scale(.6)', filter: 'brightness(.35) saturate(1.8) hue-rotate(-14deg)' },
      { opacity: 1, transform: 'scale(1.04)', filter: 'brightness(.7) saturate(1.5) hue-rotate(-8deg)', offset: 0.45 },
      { opacity: 1, transform: 'scale(1)', filter: 'brightness(1) saturate(1) hue-rotate(0deg)' }],
      { duration: 1300, delay: 100, fill: 'forwards', easing: 'ease-out' });
    // the haze blooms with a flash, then flickers like a candle in a jack-o'-lantern
    haze.animate([{ opacity: 0, transform: 'scale(.4)' }, { opacity: 1, transform: 'scale(1.1)', offset: 0.55 }, { opacity: .85, transform: 'scale(1)' }],
      { duration: 900, fill: 'forwards', easing: 'ease-out' }).onfinish = function () {
      haze.animate([{ opacity: .85, transform: 'scale(1)' }, { opacity: .55, offset: .07 }, { opacity: .9, offset: .14 }, { opacity: .7, transform: 'scale(1.05)', offset: .4 },
        { opacity: .95, offset: .52 }, { opacity: .6, offset: .58 }, { opacity: .9, transform: 'scale(.98)', offset: .8 }, { opacity: .85, transform: 'scale(1)' }],
        { duration: 3100, iterations: Infinity, easing: 'ease-in-out' });
    };
    ring.animate([{ opacity: 0, transform: 'scale(.85)' }, { opacity: .9, transform: 'scale(1)', offset: 0.4 }, { opacity: .7, transform: 'scale(1.08)' }],
      { duration: 3200, delay: 350, fill: 'forwards', easing: 'ease-out' });
    beam.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 900, delay: 450, fill: 'forwards', easing: 'ease-out' }).onfinish = function () {
      beam.animate([{ opacity: 1 }, { opacity: .65, offset: .1 }, { opacity: .95, offset: .2 }, { opacity: .7, offset: .55 }, { opacity: 1, offset: .62 }, { opacity: .8 }],
        { duration: 2300, iterations: Infinity });
    };

    // the TXI tile glows while the bats gather on it
    tileEl.animate([{ boxShadow: '0 0 0 rgba(244,94,5,0)' }, { boxShadow: '0 0 22px 4px rgba(244,94,5,.55)' }, { boxShadow: '0 0 6px 1px rgba(244,94,5,.25)' },
      { boxShadow: '0 0 26px 6px rgba(244,94,5,.6)' }, { boxShadow: '0 0 0 rgba(244,94,5,0)' }], { duration: 2600, delay: 900 });

    var n = phone ? 12 : 16, seed = 3;
    var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
    for (var i = 0; i < n; i++) {
      var size = (phone ? 16 : 18) + Math.round(rnd() * (phone ? 14 : 20));
      // circle the TXI logo, each bat on its own spot
      var ang = (i / n) * Math.PI * 2, rx = logo.w * 0.75 + 10, ry = logo.h * 0.9 + 6;
      var ox = logo.cx + Math.cos(ang) * rx, oy = logo.cy + Math.sin(ang) * ry;
      var path = [[mcx - size / 2, mcy - 6, 0], [ox - size / 2, oy - 6, rnd() * 20 - 10]];
      if (phone) {
        // then all over the header, and up and away
        path.push([rnd() * (W - size), rnd() * (H - 20), rnd() * 24 - 12]);
        path.push([rnd() * (W - size), rnd() * (H * 0.6), rnd() * 24 - 12]);
        path.push([rnd() * (W - size), -60, 0]);
      } else {
        // then off to the left across the header
        var lane = 8 + rnd() * (H - 30);
        path.push([logo.cx - 120 - rnd() * 160, lane + rnd() * 20 - 10, -8]);
        path.push([W * (0.25 + rnd() * 0.2), lane, 6]);
        path.push([-80, lane + rnd() * 30 - 15, 0]);
      }
      flyBat(over, size, path, (phone ? 3000 : 3200) + Math.round(rnd() * 500), 700 + i * 70, 0.95);
    }
    // the moon goes once the last bats have left it
    var gone = 700 + n * 70 + 900;
    // the moon, its glow, halo, wisps and light fade out where they are
    var fadeAt = Math.max(gone, 1900);
    setTimeout(function () {
      moonBox.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 1300, fill: 'forwards', easing: 'ease-in-out' });
    }, fadeAt);
    setTimeout(function () { over.remove(); }, gone + 3800);
  }


  function start() {
    header = document.querySelector('.shopify-section-group-header-group');
    if (!header || !Element.prototype.animate) return;
    // only at the top of the page, where the whole header is in view
    if (window.scrollY > 40) return;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
    swarm();
  }
  if (document.readyState === 'complete') setTimeout(start, 400);
  else window.addEventListener('load', function () { setTimeout(start, 400); });
})();
